var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMathsIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.961,
    height: 36.062,
    viewBox: "0 0 80.961 36.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.484,
    y1: -0.048,
    x2: 0.452,
    y2: -1.072,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#f15a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#ffb501"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.111,
    y1: 0.491,
    x2: 1.108,
    y2: 0.491,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff551"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.251,
    y1: 0.532,
    x2: 1.214,
    y2: 0.532,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.217,
    y1: 0.577,
    x2: 1.247,
    y2: 0.577,
    xlinkHref: "#linear-gradient-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089",
    transform: "translate(-244.445 -219.034)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M317.454,229.468a5.1,5.1,0,0,0-1.447-.148,3.944,3.944,0,0,0-.9.141l-3.052.873c-.264-.2-.528-.4-.807-.6q-.365-.276-.751-.545c-.237-.163-.468-.321-.707-.477q-.6-.395-1.227-.764c-.289-.172-.571-.339-.856-.5-.712-.4-1.45-.791-2.212-1.164q-.462-.231-.945-.456-.315-.15-.654-.292c-.574-.267-1.186-.524-1.8-.774-.327-.136-.668-.269-1-.4-.87-.329-1.757-.648-2.665-.942-.352-.118-.7-.231-1.061-.339q-1.393-.432-2.832-.8c-.358-.1-.73-.191-1.1-.28-.982-.241-1.971-.456-2.97-.655-.372-.069-.737-.14-1.111-.2-1-.186-2.023-.348-3.049-.49-.369-.05-.751-.1-1.13-.146-.288-.033-.581-.07-.871-.1-.736-.084-1.48-.16-2.215-.219-.369-.027-.744-.051-1.119-.076-1.028-.066-2.06-.113-3.078-.133-.37-.013-.736-.016-1.1-.018-1.02-.007-2.023.006-3.032.045-.27.01-.553.019-.825.036-.085,0-.17,0-.25.011a55.242,55.242,0,0,0-13.37,2.276c-.131.04-.269.083-.4.128-.289.09-.566.182-.844.281-.782.267-1.523.55-2.24.851-.266.106-.514.219-.762.332-.3.134-.6.274-.886.412-.384.185-.755.371-1.115.566-.23.125-.448.252-.673.381-.615.351-1.188.718-1.732,1.1-.2.139-.4.278-.589.418-.519.391-1,.794-1.448,1.2-.171.153-.328.3-.482.46a15.294,15.294,0,0,0-1.164,1.284c-.129.162-.257.325-.38.491a12.354,12.354,0,0,0-.856,1.351c-.1.17-.191.344-.272.519a11.5,11.5,0,0,0-.558,1.4c-.058.185-.115.364-.16.545a9.79,9.79,0,0,0-.255,1.43c-.021.184-.036.373-.045.559a10.556,10.556,0,0,0,.036,1.442c.015.189.047.385.08.574a10.01,10.01,0,0,0,.313,1.431c.057.193.12.383.188.578a12.966,12.966,0,0,0,.6,1.406c.093.192.192.382.3.577q.376.673.841,1.353c.136.19.276.384.423.576.32.432.676.865,1.056,1.295.166.186.339.369.517.557l.363.368c.29.282.592.567.911.852.2.18.407.359.623.535.08.077.179.154.265.229l-2.676.765a1.28,1.28,0,0,0-.857.6.664.664,0,0,0,.009.586,1.507,1.507,0,0,0,.46.543l6.158,4.792,71.128-19.728-.163-.626-6.162-4.618A3.594,3.594,0,0,0,317.454,229.468ZM263.128,244.3c-.1-.066-.19-.136-.279-.206-6.4-5.057-3.971-11.491,5.662-14.38a31.5,31.5,0,0,1,4.682-1.01,41.1,41.1,0,0,1,11.216.013c5.5.746,10.581,2.558,13.86,5.231a2.954,2.954,0,0,1,.255.224Z",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M317.675,228.539a5.1,5.1,0,0,0-1.447-.148,3.952,3.952,0,0,0-.9.141l-3.052.873c-.264-.2-.528-.4-.807-.6q-.364-.276-.751-.545c-.237-.163-.468-.321-.707-.477q-.6-.395-1.227-.764c-.289-.172-.571-.339-.856-.5-.712-.4-1.45-.791-2.212-1.164-.308-.154-.622-.306-.945-.456q-.315-.15-.654-.292c-.574-.267-1.185-.524-1.8-.774-.326-.137-.668-.269-1-.4-.87-.329-1.757-.648-2.665-.943-.352-.117-.7-.23-1.061-.338q-1.394-.432-2.832-.8c-.358-.1-.73-.191-1.1-.279-.982-.242-1.971-.457-2.97-.656-.372-.069-.737-.14-1.111-.2-1-.186-2.023-.348-3.049-.49-.369-.051-.751-.1-1.13-.146-.288-.033-.581-.071-.871-.1-.736-.084-1.48-.159-2.215-.219-.368-.027-.744-.051-1.119-.076-1.028-.066-2.06-.113-3.078-.133-.37-.013-.736-.016-1.1-.018-1.019-.007-2.023.006-3.032.045-.27.01-.553.019-.825.036-.085,0-.17,0-.25.011a55.29,55.29,0,0,0-13.37,2.275c-.131.041-.269.084-.4.129-.289.09-.566.182-.844.28-.782.267-1.523.551-2.24.852-.266.106-.514.219-.762.332-.3.134-.6.274-.886.412-.384.184-.755.371-1.115.566-.23.125-.448.252-.673.381-.615.351-1.188.717-1.732,1.1-.2.139-.4.277-.588.418-.519.391-1,.794-1.449,1.2-.171.153-.328.3-.482.46a15.14,15.14,0,0,0-1.164,1.284c-.129.162-.257.325-.38.491a12.356,12.356,0,0,0-.856,1.351c-.1.17-.191.343-.272.519a11.433,11.433,0,0,0-.558,1.4c-.058.185-.115.364-.16.545a9.792,9.792,0,0,0-.255,1.43c-.021.184-.036.373-.045.559a10.557,10.557,0,0,0,.036,1.442c.015.189.047.385.08.574a9.97,9.97,0,0,0,.313,1.43c.057.193.12.384.188.579a12.967,12.967,0,0,0,.6,1.406c.093.192.192.382.3.577q.375.673.84,1.353c.136.19.276.384.423.576.32.432.676.865,1.056,1.295.166.186.339.369.517.557l.363.368c.29.282.592.567.912.852.2.18.406.359.622.535.08.077.179.154.265.228l-2.676.766a1.28,1.28,0,0,0-.857.6.664.664,0,0,0,.009.586,1.507,1.507,0,0,0,.46.543l6.158,4.792,71.128-19.728-6.324-5.244A3.6,3.6,0,0,0,317.675,228.539Zm-54.326,14.83c-.1-.066-.19-.136-.279-.206-6.4-5.057-3.971-11.491,5.662-14.38a31.5,31.5,0,0,1,4.682-1.01,41.065,41.065,0,0,1,11.216.013c5.5.746,10.581,2.558,13.86,5.231a3.126,3.126,0,0,1,.255.223Z",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M273.152,219.117l.262,8.656a31.5,31.5,0,0,0-4.682,1.01c-9.633,2.889-12.065,9.323-5.662,14.38.089.07.177.14.279.206l10.46-2.993.256,8.3-17.856,4.952-1.8-30.223c.291-.138.589-.278.886-.412.248-.113.5-.226.762-.332.717-.3,1.458-.585,2.24-.852.278-.1.555-.19.844-.28.126-.045.264-.088.4-.129a55.29,55.29,0,0,1,13.37-2.275C272.982,219.122,273.067,219.119,273.152,219.117Z",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M304.112,224.607l-.252,15.808-18.981,5.265-.115-8.439,13.981-4a3.126,3.126,0,0,0-.255-.223c-3.279-2.673-8.357-4.485-13.86-5.231l-.107-8.3c.29.026.583.064.871.1.379.042.761.1,1.13.146,1.026.142,2.048.3,3.049.49.374.062.739.133,1.111.2,1,.2,1.988.414,2.97.656.367.088.739.181,1.1.279q1.441.372,2.832.8c.362.108.709.221,1.061.338.908.295,1.795.614,2.665.943.336.129.678.261,1,.4C302.927,224.083,303.538,224.34,304.112,224.607Z",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsIcon1);
export default __webpack_public_path__ + "static/media/maths-icon-1.c621999e9e6d61d6d261e1a03ad9d55d.svg";
export { ForwardRef as ReactComponent };